import { type UseMutationOptions, useMutation } from '@tanstack/vue-query'
import type { AxiosResponse } from 'axios'
import { axiosInstance } from '@/modules/Core/plugins/axios'
import type { AffiliatePayload } from '@/modules/Affiliate/types/api/payload'
import type { AffiliateApplicationSuccessResponse } from '@/modules/Affiliate/types/api/response'

const ENDPOINT = '/tripmentor/affiliate'

export function createAffiliateApplication(payload: AffiliatePayload) {
  return axiosInstance.post<AffiliateApplicationSuccessResponse>(
    ENDPOINT,
    payload
  )
}

export function useCreateAffiliateApplicationMutation(
  options?: UseMutationOptions<
    AxiosResponse<AffiliateApplicationSuccessResponse>,
    AxiosCustomError,
    AffiliatePayload,
    any
  >
) {
  return useMutation({
    mutationFn: createAffiliateApplication,
    ...options,
  })
}
